<h2 mat-dialog-title>{{ isEdit ? 'Modifica tipo struttura' : 'Nuovo tipo struttura' }}</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="tipo-struttura-form">
    @if (errorMessage) {
      <p class="text-danger mb-3">{{ errorMessage }}</p>
    }
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Id (oid_2)</mat-label>
      <input matInput type="number" formControlName="id" />
      @if (form.get('id')?.hasError('required') && form.get('id')?.touched) {
        <mat-error>Obbligatorio</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Codice</mat-label>
      <input matInput formControlName="codice" />
      @if (form.get('codice')?.hasError('required') && form.get('codice')?.touched) {
        <mat-error>Obbligatorio</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Descrizione</mat-label>
      <input matInput formControlName="descrizione" />
      @if (form.get('descrizione')?.hasError('required') && form.get('descrizione')?.touched) {
        <mat-error>Obbligatorio</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="form.invalid || submitting">
    {{ submitting ? 'Salvataggio...' : (isEdit ? 'Salva' : 'Crea') }}
  </button>
</mat-dialog-actions>
